<template>
  <div>
    <SeedJung_Header></SeedJung_Header>    
    <div class="counselor-list-container">
      <div class="container">
        <div class="header-content">
          <h1 class="main-title">상담사 소개</h1>
          <p class="subtitle">당신의 변화를 이끌어갈 최고의 파트너</p>
        </div>
        <div class="counselor-grid">
          <router-link 
            class="counselor-card" 
            :to="{ name: 'counselor-ysc' }"
          >
            <div class="card-image">
              <img :src="require('@/assets/channy/seedjung_best_3.jpg')" alt="염성찬 상담사" />
            </div>
            <div class="counselor-info">
              <h3>대표 상담사 염성찬</h3>
              <p class="specialty">체형 교정 / 벌크업 전문</p>
            </div>
          </router-link>
 
          <!-- 상담사 모집 카드 -->
          <div class="counselor-card recruitment">
            <div class="recruitment-content">
              <div class="icon">+</div>
              <h3>함께할 상담사를 모집합니다</h3>
              <p class="recruitment-text">시드정과 함께 성장할 열정 있는 상담사를 기다립니다</p>
              <button class="apply-btn" @click="handleRecruitmentClick">지원하기</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
 </template>
 
 <script>
 import SeedJung_Header from './SeedJung_Header.vue'
 
 export default {
  name: 'SeedJung_CounselorList',
  components: {
    SeedJung_Header
  },
  methods: {
    handleRecruitmentClick() {
      alert('문의사항은 seed@seedjung.co.kr으로 연락주세요.');
    }
  }
 }
 </script>
 
 <style scoped>
 .counselor-list-container {
  max-width: 100%;
  padding-top: 200px;
  margin: 0 auto;
  overflow-x: hidden;
 }
 
 .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
 }
 
 .header-content {
  text-align: center;
  margin-bottom: 60px;
 }
 
 .main-title {
  font-size: 2.8rem;
  font-weight: 600;
  color: #072c53;
  margin-bottom: 6px;
  letter-spacing: -0.5px;
 }
 
 .subtitle {
  font-size: 1.3rem;
  color: #666;
  line-height: 1.6;
  font-weight: 400;
 }
 
 .counselor-grid {
  display: flex;
  justify-content: center;
  gap: 30px;
  flex-wrap: wrap;
  margin-bottom: 40px;
 }
 
 .counselor-card {
  width: 300px;
  max-width: 100%;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-decoration: none;
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
 }
 
 .counselor-card:hover {
  transform: translateY(-5px);
 }
 
 .card-image {
  width: 100%;
  height: 400px;
  overflow: hidden;
 }
 
 .card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
 }
 
 .counselor-info {
  padding: 20px;
  background: white;
  flex-shrink: 0;
 }
 
 .counselor-info h3 {
  font-size: 18px;
  color: #333;
  margin: 0 0 8px 0;
 }
 
 .specialty {
  font-size: 14px;
  color: #666;
  margin: 0;
 }
 
 /* 모집 카드 스타일 */
 .recruitment {
  height: 460px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #f8f9fa;
  border: 2px dashed #072c53;
  cursor: pointer;
 }
 
 .recruitment-content {
  padding: 40px 20px;
 }
 
 .icon {
  font-size: 48px;
  color: #072c53;
  margin-bottom: 20px;
 }
 
 .recruitment h3 {
  color: #072c53;
  margin-bottom: 15px;
 }
 
 .recruitment-text {
  color: #666;
  margin-bottom: 25px;
 }
 
 .apply-btn {
  background: #072c53;
  color: white;
  border: none;
  padding: 10px 25px;
  border-radius: 25px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
 }
 
 .apply-btn:hover {
  background: #0a3d7a;
 }
 
 .counselor-card.recruitment:hover {
  border-color: #0a3d7a;
  background: #fff;
 }
 
 @media (max-width: 768px) {
  .counselor-list-container {
    padding-top: 80px;
  }
 
  .header-content {
    margin-bottom: 20px;
  }
 
  .main-title {
    font-size: 2.2rem;
  }
 
  .subtitle {
    font-size: 1.1rem;
  }
 
  .counselor-card {
    width: 100%;
    max-width: 320px;
  }
 
  .card-image {
    height: 430px;
  }
 
  .recruitment {
    height: 400px;
  }
 
  .recruitment-content {
    padding: 30px 15px;
  }
 
  .icon {
    font-size: 36px;
    margin-bottom: 15px;
  }
 }
 
 @media (max-width: 480px) {
  .counselor-list-container {
    padding-top: 80px;
  }
 
  .container {
    padding: 0 15px;
  }
 
  .main-title {
    font-size: 1.8rem;
  }
 
  .subtitle {
    font-size: 1rem;
  }
 
  .recruitment h3 {
    font-size: 16px;
  }
 
  .recruitment-text {
    font-size: 14px;
  }
 
  .apply-btn {
    font-size: 14px;
    padding: 8px 20px;
  }
 }
 </style>